/// <reference path="callCenter.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.CallCenter {

  class CallCenterModalController {
    modalData: Array<Object>;
    serviceData: Array<Object>;
    firstNameData: Array<Object>;
    lastNameData: Array<Object>;

    static $inject = ["item", "$mdDialog", "$mdToast"];
    public currentPane: Object;
    public item: any;
    public paneCtrl: Object;
    public mdDialog: ng.material.IDialogService;
    public mdToast: angular.material.IToastService;

    protected startDate: any;
    protected endDate: any;
    protected startTime: any;
    protected endTime: any;
    protected timeType: any;
    protected canApply: boolean;

    constructor(item: any, $mdDialog: ng.material.IDialogService, $mdToast: angular.material.IToastService) {
      this.mdDialog = $mdDialog;
      this.mdToast = $mdToast;

      if (item.startDate && item.endDate) {
        this.startDate = item.startDate;
        this.endDate = item.endDate;
      } else if (item.startTime && item.endTime && item.timeType) {
        this.startTime = item.startTime;
        this.endTime = item.endTime;
        this.timeType = item.timeType;
      }

      this.canApply = true;

    }

    startDateChanged = () => {
      if (moment(this.startDate).startOf('day').isBefore(moment().startOf('day'))) {
        this.startDate = moment().startOf('day').toDate();
        this.canApply = true;

        var toast = this.mdToast.simple();
        toast.theme("error-toast");
        toast.textContent("The start date cannot be before today.");
        toast.position("top right");
        toast.parent(angular.element("div#dateDiv"));
        toast.hideDelay(2000);
        this.mdToast.show(toast);
      } else if (moment(this.endDate).startOf('day').isBefore(moment(this.startDate).startOf('day'))) {
        this.endDate = moment(this.startDate).add(1, 'd').toDate();
        this.canApply = true;
      }
    }

    endDateChanged = () => {
      if (moment(this.endDate).startOf('day').isBefore(moment(this.startDate).startOf('day'))) {
        this.endDate = moment(this.startDate).add(1, 'd').toDate();
        this.canApply = true;

        var toast = this.mdToast.simple();
        toast.theme("error-toast");
        toast.textContent("The end date must be after the start date.");
        toast.position("top right");
        toast.parent(angular.element("div#dateDiv"));
        toast.hideDelay(2000);
        this.mdToast.show(toast);
      } else {
        this.canApply = true;
      }
    }

    getStartLabelText = (): string => {
      var retVal = "";
      switch (this.timeType) {
        case Meevo.Model.ScanTimeTypeEnum.StartsAfter:
          retVal = "Starts After:";
          break;
        default:
          retVal = "Start Time:";
          break;
      }

      return retVal;
    }

    getEndLabelText = (): string => {
      var retVal = "";
      switch (this.timeType) {
        case Meevo.Model.ScanTimeTypeEnum.EndsBefore:
          retVal = "Ends Before:";
          break;
        default:
          retVal = "End Time:";
          break;
      }

      return retVal;
    }

    showBothTimes = (): boolean => {
      return this.timeType === Meevo.Model.ScanTimeTypeEnum.Custom;
    }

    showStartTime = (): boolean => {
      return this.timeType === Meevo.Model.ScanTimeTypeEnum.StartsAfter;
    }

    showEndTime = (): boolean => {
      return this.timeType === Meevo.Model.ScanTimeTypeEnum.EndsBefore;
    }

    timeChanged = () => {
      if (this.showBothTimes() && moment(this.endTime).isBefore(moment(this.startTime))) {
        this.endTime = moment(this.startTime).add(1, 'h').toDate();
        this.canApply = false;

        var toast = this.mdToast.simple();
        toast.theme("error-toast");
        toast.textContent("The end time must be after the start time.");
        toast.position("top right");
        toast.parent(angular.element("div#timeDiv"));
        toast.hideDelay(2000);
        this.mdToast.show(toast);
      } else {
        this.canApply = true;
      }
    }

    applyDates = () => {
      this.mdDialog.hide({ startDate: this.startDate, endDate: this.endDate });
    }

    applyTimes = () => {
      this.mdDialog.hide({ startTime: this.startTime, endTime: this.endTime });
    }

    closeModal = () => {
      this.mdDialog.cancel();
    }
  }



  angular.module("meevo.plugins.callCenter")
    .controller("meevo.plugins.callCenter.callCenterModalController", CallCenterModalController);
}
